import React from 'react';
import { createTheme,responsiveFontSizes } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import {
  clientMain,
  clientPrimary,
  clientPrimaryShadow,
  clientSecondary,
  companyMain,
  companyPrimary,
  companyPrimaryShadow,
  companySecondary, deepPurpleMain,
  deepPurplePrimary, deepPurplePrimaryShadow, deepPurpleSecondary,
  employeeMain,
  employeePrimary,
  employeePrimaryShadow,
  employeeSecondary,
  glAccountMain,
  glAccountPrimary,
  glAccountPrimaryShadow,
  glAccountSecondary,
  passwordMain,
  passwordPrimary,
  passwordPrimaryShadow,
  passwordSecondary,
  settingsMain,
  settingsPrimary,
  settingsPrimaryShadow,
  settingsSecondary
} from "../colorCode/colorCode";

let theme = createTheme({
  palette: {
    primary: {
      main: '#6a9fc8',
    },
    secondary: {
      main: '#11cb5f',
    },
    warning: {
      main: '#ff9800',
    },
    error: {
      main: '#f44336',
    },
    info: {
      main: '#2196f3',
    },
    success: {
      main: '#4caf50',
    },
  },
  passwordColor:{
    primary      :passwordPrimary,
    primaryShadow:passwordPrimaryShadow,
    secondary    :passwordSecondary,
    main         :passwordMain,
  },

  glAccountColor:{
    primary      :glAccountPrimary,
    primaryShadow:glAccountPrimaryShadow,
    secondary    :glAccountSecondary,
    main         :glAccountMain,
  },

  companyColor:{
    primary      :companyPrimary,
    primaryShadow:companyPrimaryShadow,
    secondary    :companySecondary,
    main         :companyMain,
  },

  clientColor:{
    primary      :clientPrimary,
    primaryShadow:clientPrimaryShadow,
    secondary    :clientSecondary,
    main         :clientMain,

  },
  employeeColor:{
    primary      :employeePrimary,
    primaryShadow:employeePrimaryShadow,
    secondary    :employeeSecondary,
    main         :employeeMain,

  },
  settingsColor:{
    primary      :settingsPrimary,
    primaryShadow:settingsPrimaryShadow,
    secondary    :settingsSecondary,
    main         :settingsMain,
  },
  logsColor:{
    primary      :deepPurplePrimary,
    primaryShadow:deepPurplePrimaryShadow,
    secondary    :deepPurpleSecondary,
    main         :deepPurpleMain,
  },
  // greenColor:{
  //   main:greenColor
  // },
  // redColor:{
  //   main:redColor
  // },
  // yellowColor:{
  //   main:yellowColor
  // },
  // blueColor:{
  //   main:blueColor
  // },
  typography: {
    fontFamily: [
      '"Montserrat", sans-serif'
    ].join(','),
  },
});
theme = responsiveFontSizes(theme);
export default function CommonTheme(props) {
  return (
    <ThemeProvider theme={theme}>
      {props.children}
    </ThemeProvider>
  );
}
